import { Component } from '@angular/core';
import { AuthService } from 'src/services/auth/auth.service';
import * as buildInfo from 'src/environments/buildInfo';

@Component({
  selector: 'ribbon-for-debug',
  standalone: true,
  imports: [],
  templateUrl: './ribbon-for-debug.component.html',
  styleUrl: './ribbon-for-debug.component.scss',
})
export class RibbonForDebugComponent {
  buildInfo = buildInfo;

  constructor(public authService: AuthService) {}
}
